import * as angular from 'angular';
import { AddContentComponent } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components/addContent/addContent.component';
import { ContentsComponent } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components/contents/contents.component';
import { ContentTypeComponent } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components/contentType/contentType.component';
export const contentTabComponents = angular
    .module('contentTabComponents', [])
    .component('addContent', AddContentComponent)
    .component('contentType', ContentTypeComponent)
    .component('contents', ContentsComponent)
    .name;
